import { authFetch, BASE_BACKEND_URL } from '../../auth'
import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import ReactDOM from 'react-dom'
import Pagination from '../../layout/Pagination'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import SearchInput from '../../layout/SearchInput'
import { Table } from 'react-bootstrap'
import GuidanceNote from '../../components/GuidanceNote'
import { buildPriceListApiUrl } from './helpers/priceListUrlHelpers'

const ProductsPriceListTab = ({ id }) => {
  const navigate = useNavigate()
  const searchInput = useRef(null)
  const [data, setData] = useState([])
  const [isFetching, setIsFetching] = useState(true)
  const [perPage] = useState(25)
  const [totalPages, setTotalPages] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [query, setQuery] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    fetchProducts()
  }, [query, currentPage])

  const fetchProducts = () => {
    setIsFetching(true)
    setError('')

    const params = new URLSearchParams({
      page: currentPage,
      per_page: perPage
    })
    if (query) params.set('q', query)

    authFetch(
      `${buildPriceListApiUrl(BASE_BACKEND_URL, 'price_lists', id, 'product_pricelist')}?${params.toString()}`,
      {
        method: 'GET'
      }
    )
      .then((response) => {
        if (!response?.ok) throw new Error('No se pudieron cargar los productos.')
        return response.json()
      })
      .then((data) => {
        if (!Array.isArray(data?.table)) throw new Error('Respuesta de productos inválida.')
        setData(data.table)
        setTotalPages(Math.ceil(data.count / perPage))
      })
      .catch(() => {
        setData([])
        setTotalPages(1)
        setError('No se pudieron cargar los productos. Intenta de nuevo.')
      })
      .finally(() => setIsFetching(false))
  }

  const handlePaginationClick = (event) => {
    if (event.target.tagName === 'A') {
      handlePagination(event.target)
    } else if (event.target.tagName === 'svg') {
      handlePagination(event.target.parentNode)
    } else if (event.target.tagName === 'path') {
      handlePagination(event.target.parentNode.parentNode)
    }
  }

  const handlePagination = (target) => {
    if (target.id === 'first-page' && currentPage !== 1) {
      setCurrentPage(1)
    } else if (target.id === 'last-page' && currentPage !== totalPages) {
      setCurrentPage(totalPages)
    } else if (target.id === 'previous-page' && currentPage !== 1) {
      setCurrentPage(currentPage - 1)
    } else if (target.id === 'next-page' && currentPage !== totalPages) {
      setCurrentPage(currentPage + 1)
    }
  }

  const handleSearch = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault()
      setQuery(event.target.value)
      setCurrentPage(1)
    }
  }

  const deleteSearch = () => {
    setQuery('')
    setCurrentPage(1)
    searchInput.current.value = ''
  }

  const showModel = (event) => {
    event.preventDefault()
    const id = event.target.id
    navigate(`/productos/${id}/detalles`)
  }

  return (
    <div>
      <div className="title-and-search-containter mt-30">
        <h4>Productos asignados a esta lista de precio:</h4>
        <div onKeyDown={handleSearch} className="search-input-containter mb-20">
          <SearchInput
            ref={searchInput}
            query={query}
            onSearch={setQuery}
            placeholder="Buscar clientes por código, nombre"
          />
        </div>
      </div>
      <div>
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        {!isFetching && data.some((model) => model.within_scope === false) && (
          <GuidanceNote
            title="Lista compartida"
            message="Puedes ver los productos de esta lista. Solo los productos asignados a ti permiten abrir su detalle o modificar su relación."
            sx={{ mb: 2 }}
          />
        )}
        <Table hover responsive>
          <thead className="table-header-gray">
            <tr>
              <th className="vertical-align-middle">
                <span className="th-header-text">CÓDIGO</span>
              </th>
              <th className="vertical-align-middle">
                <span className="th-header-text">NOMBRE</span>
              </th>
              <th className="vertical-align-middle">
                <span className="th-header-text">UNIDAD DE VENTA</span>
              </th>
              <th className="vertical-align-middle">
                <span className="th-header-text">PRECIO</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {isFetching && (
              <tr>
                <td colSpan="4" className="td-text-limited td-text-limited-space">
                  Obteniendo datos...
                </td>
              </tr>
            )}
            {!isFetching &&
              data?.length > 0 &&
              data?.map((model, index) => (
                <tr
                  className={model.within_scope === false ? '' : 'cursor-pointer'}
                  key={index}
                  aria-disabled={model.within_scope === false}
                  title={
                    model.within_scope === false
                      ? 'Solo lectura: fuera de tus asignaciones'
                      : undefined
                  }
                  style={model.within_scope === false ? { opacity: 0.6 } : undefined}
                >
                  <td
                    className="td-text-limited"
                    id={model.id}
                    onClick={model.within_scope === false ? undefined : showModel}
                  >
                    {model.db_ref}
                  </td>
                  <td
                    className="td-text-limited"
                    id={model.id}
                    onClick={model.within_scope === false ? undefined : showModel}
                  >
                    {model.name}
                  </td>
                  <td
                    className="td-text-limited"
                    id={model.id}
                    onClick={model.within_scope === false ? undefined : showModel}
                  >
                    {model.package ? model.package.unit : ''}
                  </td>
                  <td
                    className="td-text-limited"
                    id={model.id}
                    onClick={model.within_scope === false ? undefined : showModel}
                  >
                    {model.price}
                  </td>
                </tr>
              ))}
            {!isFetching && !error && data?.length === 0 && (
              <tr>
                <td colSpan="4" className="td-text-limited td-text-limited-space">
                  No hay resultados
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        {totalPages > 1 && (
          <nav className="index-table">
            <Pagination
              current_page={currentPage}
              total_pages={totalPages}
              handle_pagination={handlePaginationClick}
            />
          </nav>
        )}
      </div>
    </div>
  )
}

export default ProductsPriceListTab
